import React from "react";
import { useSelector } from "react-redux";
import { Box, Stack, Typography } from "@mui/material";
import { validateObject } from "helpers/validateObject";

const buildAddress = (
  { street, extNumber, intNumber, colony, municipality, state, postalCode }
) => {
  const streetLine = street ? `${street} ${extNumber || "S/N"}` : null;
  const parts = [streetLine];
  if (intNumber) parts.push(`Int. ${intNumber}`);
  parts.push(colony, municipality, state, postalCode);
  return parts.filter(Boolean).join(",\n");
};

export const ShipToAddressDetails = ({ gn4Account }) => {
  const { shipToAddress } = useSelector(({ erpEquivalencies }) => erpEquivalencies);
  const builtAddress = validateObject(shipToAddress) ? buildAddress(shipToAddress) : "";
  const displayedAddress = builtAddress.length > 0
    ? builtAddress
    : "Sin dirección registrada";

  return (
    <Stack spacing={2} alignItems="center" sx={{ width: "100%" }}>
      <Typography variant="subtitle1" fontWeight="bold">
        Cuenta GN4: {gn4Account}
      </Typography>
      <Box
        sx={{
          border: 1,
          borderColor: "grey.400",
          borderRadius: 2,
          p: 2,
          width: "100%",
        }}
      >
        <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
          {displayedAddress}
        </Typography>
      </Box>
    </Stack>
  );
};
